function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9502 2.05025C10.6279 0.728134 8.87012 0 7 0C5.12988 0 3.37207 0.728134 2.0498 2.05025C0.728516 3.37237 0 5.13022 0 7C0 8.86976 0.728516 10.6276 2.0498 11.9498C3.37207 13.2719 5.12988 14 7 14C8.87012 14 10.6279 13.2719 11.9502 11.9498C13.2715 10.6276 14 8.86976 14 7C14 5.13022 13.2715 3.37237 11.9502 2.05025ZM7.875 10.5C7.875 10.9832 7.4834 11.375 7 11.375C6.5166 11.375 6.125 10.9832 6.125 10.5V6.125C6.125 5.64175 6.5166 5.25 7 5.25C7.4834 5.25 7.875 5.64175 7.875 6.125V10.5ZM6.125 3.5C6.125 3.98325 6.5166 4.375 7 4.375C7.4834 4.375 7.875 3.98325 7.875 3.5C7.875 3.01675 7.4834 2.625 7 2.625C6.5166 2.625 6.125 3.01675 6.125 3.5Z"
});

var SvgInfoPanelOpen = function SvgInfoPanelOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#BE0921",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoPanelOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-panel-open.d22554d1.svg";
export { ForwardRef as ReactComponent };